<template>
  <div class="job-items">

    <div v-if="! rootDocumentItems().length && ! rootProductItems().length">
      <h4 class="lead">Items pending...</h4>
    </div>

    <!-- DOCUMENTS -->
    <div v-for="item in rootDocumentItems()" class="document" :key="`item-${item.line_id}`">

      <!-- Single Document -->
      <div class="item row">
        <div class="item-image col-6 offset-3 col-sm-3 offset-sm-0">
          <b-img-lazy fluid thumbnail :src="item.thumbnail_url || fallbackSource" alt="Document thumbnail" @click.native="openLightbox(item.thumbnail_url, item.name)" @error.native="fallbackImage"></b-img-lazy>
        </div>
        <div class="item-details col-sm-9 text-center text-sm-left pt-0 pt-sm-2">
          <div class="overflow-hidden">
            <span class="item-name d-block text-truncate">{{ item.name }}</span>
          </div>
          <div>
            <span class="item-preset">{{ item.preset }}</span>
          </div>
          <div>
            <span class="item-quantity">{{ item.quantity }}</span> {{ `pc` | pluralize(item.quantity) }}
            <span v-if="item.price">
              x <span class="item-price">{{ item.price }}</span> <span class="item-currency">{{ itemCurrency(item) }}</span>
            </span>
          </div>
          <div class="quantity-dropdown">
            <ClaimDropdown v-bind:quantity="item.quantity" v-bind:index="getIndexForId(item.line_id)" />
          </div>
        </div>
      </div>

      <!-- Document Includes/Products -->
      <div class="products">
        <div v-for="proditem in childItems(item.line_id)" class="product" :key="`item-${proditem.line_id}`">
          <!-- Single product -->
          <div class="item row">
            <div class="item-image col-6 offset-3 col-sm-3 offset-sm-0 pl-sm-4">
              <b-img-lazy fluid thumbnail :src="productThumbnail(proditem)" alt="Product thumbnail" @error.native="fallbackImage"></b-img-lazy>
            </div>
            <div class="item-details col-sm-9 text-center text-sm-left pt-0 pt-sm-2">
              <div class="overflow-hidden">
                <span class="item-sku d-block text-truncate">{{ proditem.sku }}</span>
              </div>
              <div class="">
                <span class="item-quantity">{{ proditem.quantity }}</span> {{ `pc` | pluralize(proditem.quantity) }}
                <span v-if="item.price">
                  x <span class="item-price">{{ proditem.price }}</span> <span class="item-currency">{{ itemCurrency(proditem) }}</span>
                </span>
                <!-- <span class="item-price">{{ item.price }}</span> <span class="item-currency">{{ itemCurrency(item) }}</span> -->
              </div>
              <div class="quantity-dropdown">
                <ClaimDropdown  :quantity="proditem.quantity" v-bind:index="getIndexForId(proditem.line_id)" />
              </div>
              <!--
              <div class="">
                <span class="item-total">{{ item.quantity * item.price }}</span> <span class="item-currency">{{ itemCurrency(item) }}</span>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- END: DOCUMENTS -->


    <!-- PRODUCTS -->
    <div v-for="item in rootProductItems()" class="product" :key="`item-${item.line_id}`">
      <!-- Single product -->
      <div class="item row">
        <div class="item-image col-6 offset-3 col-sm-3 offset-sm-0">
          <b-img-lazy fluid thumbnail :src="productThumbnail(item)" alt="Product thumbnail" @error.native="fallbackImage"></b-img-lazy>
        </div>
        <div class="item-details col-sm-9 text-center text-sm-left  pt-0 pt-sm-2">
          <div class="overflow-hidden">
            <span class="item-sku d-block text-truncate">{{ item.sku }}</span>
          </div>
          <div class="">
            <span class="item-quantity">{{ item.quantity }}</span> {{ `pc` | pluralize(item.quantity) }}
            <span v-if="item.price">
              x <span class="item-price">{{ item.price }}</span> <span class="item-currency">{{ itemCurrency(item) }}</span>
            </span>
            <!-- <span class="item-price">{{ item.price }}</span> <span class="item-currency">{{ itemCurrency(item) }}</span> -->
          </div>
          <div class="quantity-dropdown">
            <ClaimDropdown  v-bind:quantity="item.quantity" v-bind:index="getIndexForId(item.line_id)" />
          </div>
          <!--
          <div class="">
            <span class="item-total">{{ item.quantity * item.price }}</span> <span class="item-currency">{{ itemCurrency(item) }}</span>
          </div>
          -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
//import {} from 'vuex'
import ClaimDropdown from '@/components/ClaimDropdown/ClaimDropdown.vue';

export default {

  name: 'ItemClaimOrderContent',

  components: {
    ClaimDropdown,
  },

  props: {
    items: {
      type: Array,
    },
  },

  data() {
    return {}
  },

  computed: {
    levelClass() {
      return `job-items__level-${this.level}`
    },
    fallbackSource() {
      return 'data:image/png;base64,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';
    }
  },
  methods: {
    rootDocumentItems() {
      return this.items.filter(x => x?.line_type == 'document' && x?.parent_line_id == null )
    },
    rootProductItems() {
      return this.items.filter(x => x?.line_type == 'product' && x?.parent_line_id == null )
    },
    childItems( parent ) {
      return this.items.filter(x =>  x?.parent_line_id == parent )
    },
    openLightbox(src, title) {
      this.$lightIt(src, title);
    },
    itemCurrency( item ) {
      return item.currency ?? 'SEK';
    },
    fallbackImage(e) {
      e.target.src = this.fallbackSource // NOT ideal, but what to do when we get junk!
    },

    productThumbnail( item ) {
      if ( ! item.product_id ) {
        return this.fallbackSource
      }
      return `https://api.tryckeriapi.se/thumbs/production_units/alfredssons/products/${item.product_id}/thumbnail.jpg`
    },

    getIndexForId( line_id ) { // Brute force
      const index = this.items.findIndex( x => x.line_id == line_id );
      return index;
    }

  },
  mounted(){
  
  }

}

</script>

<style lang="scss" scoped>
.item-name {
  font-size: 1.2em;
}
.item-sku {
  font-size: 1.2em;
}

.document {
  padding: 1rem 0rem;
  
  &:not(:last-child) {
    border-bottom: 1px solid #dadada;
  }

  & > .item .item-image img {
    cursor: zoom-in;
  }
}
.product {
  padding-top: 1em;
}

.quantity-dropdown {
  margin-top: 1em;
}
</style>